import { DropdownMenuItem } from '@dextech-ai/dex-design-system';

export const googleAnalyticsId = (id, label) => (id ? `${id}-${label?.toLowerCase()?.replaceAll(/\s+/g, '-')}` : undefined);

export default function renderMenuItem(item, { id, onSelect }) {
	return (
		<DropdownMenuItem itemKey={item.label} key={item.label} onSelect={() => onSelect(item)}>
			<span
				className="on-boarding__menu-dropdown__menu-item-contents"
				id={googleAnalyticsId(id, item.label)}
				style={item.labelColor ? { color: item.labelColor } : undefined}
			>
				{item.label}
			</span>
		</DropdownMenuItem>
	);
}
